module.exports = __webpack_public_path__ + "img/New PACI Flow - New User AR - 3.b0d2373d.png";